<template>
    <div class="w-1280 margin-top schoolPaperSon"
         v-loading="loadingDownload" >
        <common-dialog :model-obj="modelObj" :dialogShow="dialogShow" @closeDialog="modalClose">
            <div slot="title" style="padding: 16px 24px;color: rgba(0,0,0,.65);
            background: #fff;border-bottom: 1px solid #e8e8e8;border-radius: 4px 4px 0 0;">
                <span style="font-weight: 500;color: rgb(59, 62, 66);font-size: 16px;">收藏</span>
                <span style="margin-left: 12px;color: rgb(109, 114, 120);font-size: 12px;">
                    *保存完后请进入
                    <span style="color: rgb(10, 147, 252);cursor:pointer;" @click="jumpMyCollection">
                        我的收藏
                    </span>
                    进行查看
                </span>
            </div>
            <div class="public_scroll_bar" style="overflow-y: scroll;min-height: 100px;max-height: 300px;">
                <div style="position: relative;-webkit-transition: opacity .3s;transition: opacity .3s;">
                    <div style="-webkit-box-sizing: border-box;
                            box-sizing: border-box;
                            color: rgba(0,0,0,.65);
                            font-size: 14px;
                            font-variant: tabular-nums;
                            line-height: 1.5;
                            list-style: none;
                            -webkit-font-feature-settings:'tnum';
                            font-feature-settings:'tnum';
                            margin: 0;
                            padding: 0;">
                        <div v-loading="loadingCollection" style="margin: 0;padding: 4px 20px;white-space: nowrap;list-style: none;outline: 0;padding-top:7px;">
                            <div class="tree-con" style="display: -webkit-box;
                                                        display: -ms-flexbox;
                                                        display: flex;
                                                        -webkit-box-align: center;
                                                        -ms-flex-align: center;
                                                        align-items: center;
                                                        position: relative;
                                                        height: 28px;cursor: pointer;"
                                 :class="selectDirectoryId===item.categoryId?'directoryActive':''" @click="selectDirectoryId=item.categoryId"
                                 v-for="item in collectionCatalog" :key="item.categoryId">
                                <span style="display: flex; align-items: center; padding-left: 2px; overflow: hidden;
                                                            text-overflow: ellipsis;
                                                            white-space: nowrap;
                                                            word-break: break-all;
                                                            max-width: 220px;">
                                    <span class="el-icon-document"   style="width: 10px;vertical-align: middle;border-style: none;"></span>
                                    <span style="margin-left: 15px;">{{item.categoryName}}</span>
                                </span>
                                <div class="tree-btns" style="position: absolute;right: 0; display: inline-block;margin: 0 8px 0 18px;" v-show="!item.isSys">
                                    <el-button type="text" @click="changeNameDialog(item.categoryId,item.categoryName)">重命名</el-button>
                                    <el-button type="text" @click="delCollection(item.categoryId)" class="text-danger">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="margin">
                <el-button type="button" size="mini" @click="createDirectory">新建目录</el-button>
            </div>
            <div class="dialog-footer text-right margin padding-y  border-top ">
                <el-button @click="dialogShow=false">取消</el-button>
                <el-button type="primary" v-show="!confirmCollectionLoading" @click="tapCollection">确定</el-button>
                <el-button type="primary" v-show="confirmCollectionLoading">确定...</el-button>
            </div>
        </common-dialog>
        <el-dialog
                :title="changeTitle"
                :visible.sync="changeDirectoryDialogShow"
                width="503px">
            <el-input v-model="directoryName" v-show="changeTitle==='编辑目录'"></el-input>
            <el-input v-model="directoryCreateName" v-show="changeTitle==='创建目录'"></el-input>
            <div slot="footer">
                <el-divider></el-divider>
                <el-button size="small" @click="changeDirectoryDialogShow=false">取消</el-button>
                <el-button size="small" type="primary" v-show="changeTitle==='编辑目录'&&!updateDirectoryLoading" @click="tapChangeDirectoryName">确定</el-button>
                <el-button size="small" type="primary" v-show="changeTitle==='编辑目录'&&updateDirectoryLoading" @click="tapChangeDirectoryName">确定...</el-button>
                <el-button size="small" type="primary" v-show="changeTitle==='创建目录'&&!createDirectoryLoading" @click="tapCreateDirectoryName">确定</el-button>
                <el-button size="small" type="primary" v-show="changeTitle==='创建目录'&&createDirectoryLoading" @click="tapCreateDirectoryName">确定...</el-button>
            </div>
        </el-dialog>

        <div class="topTitle commonBorder">
            <span class="leftTitle font-weight-bolder text-l-size" v-show="huiZonId===''">
                {{'【'+testPaperDetail.subjectName+'】'+testPaperDetail.name}}
            </span>
            <span v-show="huiZonId!==''" class="leftTitle font-weight-bolder text-l-size">
                【{{testPaperDetail.dataSource}}】{{testPaperDetail.title}}
            </span>
            <div class="float-right">
                <el-button  size="small" @click="downloadUp"
                           class="margin-right btnSon">下载</el-button>
                <el-button   size="small" class="  btnSon" v-show="huiZonId===''"
                           @click="controllerSelectedKj">收藏</el-button>
            </div>
        </div>
        <div class="contentFile commonBorder">
            <iframe id="iframe_src" scrolling="auto" v-show="!rightContentLoading&&fileUrl!==''" width="100%" height="1000">
            </iframe>
            <loading :show="rightContentLoading" width="850px"></loading>
            <empty v-show="!rightContentLoading&&fileUrl===''"></empty>
        </div>
        <div class="rightDescribe  commonBackground">
            <div >
                <div style="margin-top: 20px;" class="delFloat">
                    <div v-show="huiZonId===''" class="float-left">试卷类型</div><div class="float-left" v-show="huiZonId!==''">数据类型</div>
                    <div style="float: right; width:150px;" :title="testPaperDetail.paperTypeName" class="text-ellipsis" v-show="huiZonId===''">{{testPaperDetail.paperTypeName}}</div>
                    <div style="float: right;width:150px;" :title="testPaperDetail.categoryName" class="text-ellipsis" v-show="huiZonId!==''">{{testPaperDetail.categoryName}}</div>
                </div>
                <div class="delFloat"><div class="float-left">格式</div><div style="float: right;">docx</div></div>
                <p style="margin-top: 20px;"><span>上传时间</span><span style="float: right;">{{testPaperDetail.updatedAt}}</span></p>
                <p style="margin-top: 20px;">
                    <span>阅读次数</span>
                    <span style="float: right;" v-show="huiZonId===''">{{testPaperDetail.viewTimes}}</span>
                    <span style="float: right;" v-show="huiZonId!==''">{{testPaperDetail.views}}</span>
                </p>
                <p style="margin-top: 20px;"><span>下载次数</span>
                    <span v-show="huiZonId===''" style="float: right;">{{testPaperDetail.downTimes}}</span>
                    <span v-show="huiZonId!==''" style="float: right;">{{testPaperDetail.downLoads}}</span>
                </p>

            </div>
        </div>
    </div>
</template>
<script>
    import {
        cYeardataDetail, dataDownload,
        testPapeDetail,
        testPaperCreateFavCategory,
        testPaperDelFavCategory,
        testPaperDownload, testPaperFav,
        testPaperFavCategory, testPaperUpdateFavCategory
    } from "../../../config";
    import {commonDowloadFile} from "../../../assets/static/global/global";
    import {message,messageBox} from 'element-ui'
    export default {
        name: "schoolPaperSon",
        data(){
          return{
              //创建目录的名称
              directoryCreateName:'',
              //编辑目录的加载项
              updateDirectoryLoading:false,
              //创建目录的加载项
              createDirectoryLoading:false,
              selectPaperId:'',
              testPaperDetail:'',
              rightContentLoading:false,
              fileUrl:'',
              //点击下载整个页面遮罩加载
              loadingDownload:false,
              /*点击收藏出现弹窗，设置弹窗的相关配置*/
              modelObj:{
                  title:'',
                  width:'503px',
                  center:false
              },
              //控制收藏弹窗关闭
              dialogShow:false,
              //收藏夹加载
              loadingCollection:false,
              //获取所选的收藏夹的id
              selectDirectoryId:'',
              /*点击收藏按钮，查出需要收藏的相关目录*/
              collectionCatalog:[],
              confirmCollectionLoading:false,
              changeTitle:'',
              //接收所需重命名的文件夹id，根据此id修改名称
              changeNameId:'',
              //接收重命名的文件夹名称
              directoryName:'',
              changeDirectoryDialogShow:false,
              huiZonId:''
          }
        },
        mounted(){
            this.selectPaperId=this.$route.query.paperId;
            if(this.selectPaperId){
                //查出关于正常试卷的数据汇总
                this.searchTestPaper();
            }else{
                this.huiZonId=this.$route.query.huizId;
                this.cYearDataDetail(this.$route.query.huizId);
            }
        },
        methods:{
            //查询关于历史数据汇总的详情数据
            async cYearDataDetail(val){
                this.rightContentLoading=true;
                let result=await cYeardataDetail(val);
                if(result.status){
                    this.rightContentLoading=false;
                    this.testPaperDetail=result.data;
                    this.fileUrl=result.data.fileUrl;
                    this.commonFileIframeUrl();
                }else{
                    this.rightContentLoading=false;
                }
            },
            //创建收藏夹
            async tapCreateDirectoryName(){
                this.createDirectoryLoading=true;
                let result=await testPaperCreateFavCategory(this.directoryCreateName);
                if(result.status){
                    this.createDirectoryLoading=false;
                    this.changeDirectoryDialogShow=false;
                    message({
                        message:'创建成功',
                        type:'success',
                        offset:200
                    })
                    //重新查询收藏夹列表
                    this.controllerSelectedKj();
                }else{
                    this.createDirectoryLoading=false;
                }
            },
            //点击确定按钮根据收藏夹id，重命名名称
            async tapChangeDirectoryName(){
                this.updateDirectoryLoading=true;
                let result=await testPaperUpdateFavCategory(this.changeNameId,this.directoryName);
                if(result.status){
                    this.changeDirectoryDialogShow=false;
                    this.updateDirectoryLoading=false;
                    message({
                        message:'收藏成功',
                        type:'success',
                        offset:200
                    })
                    this.controllerSelectedKj();
                }else{
                    this.updateDirectoryLoading=false;
                }
            },
            //创建收藏夹弹窗显示
            createDirectory(){
                this.changeTitle='创建目录';
                this.changeDirectoryDialogShow=true;
            },
            //重名命收藏夹弹窗显示
            changeNameDialog(valId,valName){
                this.changeTitle='编辑目录';
                this.changeNameId=valId;
                this.directoryName=valName;
                this.changeDirectoryDialogShow=true;
            },
            //删除所选择的收藏夹
            delCollection(val){
                messageBox.confirm('将永久删除所选的文件夹, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                    center:true
                }).then(async() =>{
                    let result=await testPaperDelFavCategory(val);
                    if(result.status){
                        message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.controllerSelectedKj();
                    }else{
                        this.controllerSelectedKj();
                    }
                }).catch(() => {
                });
            },
            //选择某个收藏夹，点击确定收藏
            async tapCollection(){
                this.confirmCollectionLoading=true;
                let result=await testPaperFav(this.selectPaperId,1,this.selectDirectoryId);
                if(result.status){
                    this.confirmCollectionLoading=false;
                    message({
                        message:'收藏成功',
                        type:'success',
                        offset:200
                    })
                    this.dialogShow=false;
                }else{
                    this.confirmCollectionLoading=false;
                }
            },
            /*************控制已选择的课件收藏**************/
            async controllerSelectedKj(){
                this.dialogShow=true;
                this.loadingCollection=true;
                let result=await testPaperFavCategory();
                if(result.status){
                    this.loadingCollection=false;
                    this.collectionCatalog=result.data;
                }else{
                    this.loadingCollection=false;
                }
            },
            //点击收藏按钮进入收藏页查看收藏内容
            jumpMyCollection(){
                const {href} = this.$router.resolve(
                    {path:'/teacher/preparescjpage'});
                this.getLocation=href;
            },
            //控制弹窗关闭
            modalClose(){
                this.dialogShow=false;
            },
            //查出试卷详情
            async searchTestPaper(){
                this.rightContentLoading=true;
                let result=await testPapeDetail(this.selectPaperId);
                if(result.status){
                    this.testPaperDetail=result.data;
                    this.fileUrl=result.data.fileUrl;
                    this.commonFileIframeUrl();
                    this.rightContentLoading=false;
                }else{
                    this.rightContentLoading=false;
                }
            },
            commonFileIframeUrl(){
                // var id='office web 365创建的域名及端口的ID';
                // var my_url="office web 365创建的域名及端口"+"后台接口返回的文档地址或服务器保存的静态文档"
                let iframe_src='http://ow365.cn/?i=25593&furl='+this.fileUrl;
                document.getElementById('iframe_src').src=iframe_src;
                this.rightContentLoading=false;
            },
            //试卷下载
            async downloadUp(){
                this.loadingDownload=true;

                let id='';
                if(this.huiZonId){
                    this.dataDownload();
                    return false;
                }else{
                    id=this.selectPaperId;
                }
                let result=await testPaperDownload(id);
                if(result.status){
                    let zhi=window.atob(result.data);

                    var link = document.createElement("a");
                    var body = document.querySelector("body");
                    link.href =zhi;
                    link.style.display="none";
                    body.appendChild(link);
                    link.click();
                    body.removeChild(link);
                    this.loadingDownload=false;
                }else{
                    this.loadingDownload=false;
                }
            },
            async dataDownload(){
                let result=await dataDownload(this.huiZonId);
                if(result.status){
                    let zhi=window.atob(result.data);
                    var link = document.createElement("a");
                    var body = document.querySelector("body");
                    link.href =zhi;
                    link.style.display="none";
                    body.appendChild(link);
                    link.click();
                    body.removeChild(link);
                    this.loadingDownload=false;

                }else{
                    this.loadingDownload=false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .schoolPaperSon{
        .btnSon{
            background:#0060FF;
            color:#ffffff;
            border: none;
        }
        .topTitle{
            border: 0 solid #e8e8e8;
            border-radius: 4px;

            .leftTitle{
                line-height: 32px;
                color:#323030;
            }
        }
        .contentFile{
            float: left;
            margin-top: 20px;
            width: 960px;
            height: 1000px;
            border: 0 solid #e8e8e8;
            border-radius: 4px;

        }
        .rightDescribe{
            width: 280px;
            margin-top: 20px;
            float: right;
            padding: 20px;
            zoom: 1;
            div{
                margin-bottom: 1em;
                color: #383838;
            }

        }
    }
</style>